<template>
  <vis-inner-layout>
    <div class="ba-flex ba-flex-col ba-items-center ba-m-auto ba-p-4">
      <figure
        href="/"
        class="identity__logo ba-text-center ba-w-full ba-max-w-76"
      >
        <img
          class="ba-mb-4 ba-w-full ba-inline"
          src="/img/brand/white/logo.svg"
          alt="Logo"
        />
      </figure>
      <div class="splash-screen__msg ba-w-full ba-text-center">
        <span class="ba-mt-2 ba-text-center ba-text-3xl">{{ $t('page404.title') }}</span>
        <span class="ba-mt-2 ba-flex ba-flex-col ba-text-center">
          <span class="ba-mb-2">{{ $t('page404.description') }}</span>
          <router-link
            :to="{ name: 'login' }"
            class="ba-text-link ba-underline hover:ba-no-underline"
            >
            {{ $t('backToLogin') }}
          </router-link>
        </span>
      </div>
    </div>
  </vis-inner-layout>
</template>

<script>
import VisInnerLayout from "./vis-inner-layout";
export default {
  name: "vis-page404",
  components: {
    VisInnerLayout
  }
};
</script>
